import { createSelector } from "reselect";

import { getCarrierCharges } from "selectors";

export const getCarrierChargesListSelector = createSelector(
  [getCarrierCharges],
  carrierCharges => Object.values(carrierCharges),
);
